'use strict';

const util = require('./util');
const $window = $(window);
const windowHeight = $window.height();
const {isMobile} = util;
const getfixedHeaderHeight = () => {
    let $fixedHeader = $('.header').find('.fixit--active');

    return $fixedHeader.length && $fixedHeader.height() || 0;
}

function initializeEvents(options) {
    let { stickOnNode } = options;
    let stickOnNodeSelector = $(stickOnNode).length ? stickOnNode : '.footer';

    initStickySummary();

}

function initStickySummary() {
    let left = document.getElementById('cart-summary').getBoundingClientRect().left;

    $('#cart-summary').stick_in_parent({
        parent: '#wrapper'
    }).on("sticky_kit:stick", function(e) {
        $(this).css({
            //maxHeight: windowHeight - getfixedHeaderHeight() - 30,
            left
        });
    });
}

exports.init = function (options = {
    stickOnNode: ''
}) {
    if (!$('#cart-summary').length || isMobile()) return;

   // initializeEvents(options);
};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/sticky-summary.js